import $ from 'jquery';

import CSRF from 'lib/csrf.js';
import browser from 'lib/browser';

export default class ShowMoreNews {
    constructor(params) {
        const { button, container, url, loader } = params;

        this._$button = $(button);
        this._$container = $(container);
        this._url = url;
        this._sending = false;
        this._loaderClass = loader;
        this._currentPage = 1;
    }

    init() {
        this._$button.on('click', this::this._onClickShowMore);
    }

    /**
     * Обработчик нажатия на кнопку подгрузки новостей
     */
    _onClickShowMore() {
        if (this._sending) {
            return;
        }

        this._loading = true;

        this._sendToServer().then(
            this::this._successCallback,
            this::this._errorCallback
        );
    }

    /**
     * Отправка данных на сервер
     *
     * @return {Promise}
     */
    _sendToServer() {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: 'GET',
                url: this._url,
                data: {
                    page: this._currentPage + 1,
                },
                dataType: 'json',
                success: resolve,
                error: reject,
            });
        });
    }

    /**
     * Callback-функция при успешном выплнении запроса
     *
     * @param {object} response
     */
    _successCallback(response) {
        this._loading = false;

        if (response.result !== 'ok') {
            console.warn(response.error || 'Ошибка при выполнении запроса');

            return;
        }
        this._$container.append(response.html);
        this._currentPage++;

        if (countPage === this._currentPage) {
            this._$button.remove();
        }
    }

    /**
     * Callback-функция при возникновении ошибки во время выполнения запроса
     *
     * @param {object} error
     */
    _errorCallback(error) {
        this._loading = false;
        console.warn(error);
    }

    /**
     * Отобразить/убрать лоадер на кнопке
     *
     * @param  {bool} value
     */
    set _loading(value) {
        if (value) {
            this._sending = true;
            this._$button.addClass(this._loaderClass);
        } else {
            this._sending = false;
            this._$button.removeClass(this._loaderClass);
        }
    }
}
